import styles from './Patroller.module.css';

import React from "react";

import Alert from '@mui/material/Alert';
import CircularProgress from '@mui/material/CircularProgress';

import { getPatroller, getCertifications } from "../../api.js";
import { useAuth } from "../../AuthContext";

import { Badge } from '../Badge/Badge';
import { CollapsibleCard } from '../CollapsibleCard/CollapsibleCard';

export const Patroller = ({ id, onSetPatroller }) => {
    const [ error, setError ] = React.useState(null);
    const [ loading, setLoading ] = React.useState(true);
    const [ certifications, setCertifications ] = React.useState([]);
    const [ patroller, setPatroller ] = React.useState({
        id: id,
        nspNumber: '',
        firstName: '',
        lastName: '',
        phone: '',
        certifications: [],
        email: '',
        photo: null
    });

    const { auth, token } = useAuth();
    
    React.useEffect(() => {
        const fetchData = async () => {
            const patrollerData = await getPatroller(id, token);
            const certData = await getCertifications(token);
            const hasError = patrollerData?.error || certData?.error;

            if (hasError) {
                setError(hasError || 'Failed to fetch patroller data. Please try again.');
                setLoading(false);

                return;
            }

            setCertifications(certData || []);
            setPatroller(patrollerData ?? { id: id, nspNumber: '', firstName: '', lastName: '', phone: '', certifications: [], email: auth.currentUser?.email, photo: '' });

            onSetPatroller && onSetPatroller(patrollerData);

            setLoading(false);
        };

        fetchData();
    }, [ id, token, auth.currentUser?.email, onSetPatroller ]);

    const title = patroller.displayName
        ? patroller.displayName
        : 'Patroller Info';
    
    const headerIcon = (
        <img
            src={ patroller.photoURL }
            className={ styles.headerAvatar }
            alt="Profile"
        />
    );

    if (loading) {
        return <CircularProgress />;
    }

    if (error) {
        return <Alert variant='filled' severity="warning">{ error }</Alert>;
    }
        
    return (
        <CollapsibleCard
            title={ title }
            headerIcon={ headerIcon }
            initiallyExpanded={ false }
        >
            <div className={ styles.profile }>
                <div className={ styles.avatar }>
                    <img src={ `${ patroller.photoURL }` }></img>
                </div>

                <div className={ styles.info }>
                    <span>{ `${ patroller.displayName || 'Patroller' }` }</span>
                    <span className={ !patroller.nspNumber ? styles.unverified : null }>{ patroller.nspNumber || 'NSP Number' }</span>
                    <span className={ !patroller.phone ? styles.unverified : null }>{ patroller.phone || 'Phone' }</span>
                    <span className={ auth.currentUser.emailVerified ? styles.verified : styles.unverified }>{ patroller.email || 'Email' }</span>
                </div>
            </div>

            <div className={ styles.certifications }>
                {
                    certifications.map(cert => {
                        return (
                            <div key={ cert.id } className={ styles.badge }>
                                <Badge certification={ cert } certified={ patroller.certifications?.some(c => c.id === cert.id) } loading={ false } />
                            </div>
                        );
                    })
                }
            </div>

        </CollapsibleCard>
    );
};